"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _index = require("../../../helpers/index.js");
var stringField = _index.formatters.stringField;
var getSearchRefinementTemplate = function getSearchRefinementTemplate(_ref) {
  var refinementType = _ref.refinementType,
    refinementValue = _ref.refinementValue;
  return {
    _telus: {
      refinementInstances: {
        value: 1
      },
      refinementType: stringField(refinementType),
      refinementValue: stringField(refinementValue)
    }
  };
};
var _default = exports["default"] = getSearchRefinementTemplate;